import {
  SET_PO_DISPLAY_ID, SET_PO_VENDOR_ID, SET_PO_PRODUCTS, SET_PO_DATE, SET_PO_STATUS, SET_PO_PAYMENTS, SET_PO_RECEIVED, SET_NEW_PO_INFO, CLEAR_NEW_PO
} from 'redux/actionTypes';

export const setNewPODisplayId = value => ({
  type: SET_PO_DISPLAY_ID,
  payload: value
});

export const setNewPOVendorId = value => ({
  type: SET_PO_VENDOR_ID,
  payload: value
});

export const setNewPOProducts = value => ({
  type: SET_PO_PRODUCTS,
  payload: value
});

export const setNewPODate = value => ({
  type: SET_PO_DATE,
  payload: value
});

export const setNewPOStatus = value => ({
  type: SET_PO_STATUS,
  payload: value
});

export const setNewPOPayments = value => ({
  type: SET_PO_PAYMENTS,
  payload: value
});

export const setNewPOReceived = value => ({
  type: SET_PO_RECEIVED,
  payload: value
});

export const setNewPOInfo = data => ({
  type: SET_NEW_PO_INFO,
  payload: data
});

export const clearNewPO = () => ({
  type: CLEAR_NEW_PO
});